const Package = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='73.569'
    height='78.354'
    viewBox='0 0 73.569 78.354'
    fill='#0e77ef'
    {...props}
  >
    <path
      id='package'
      d='M67.922,14.431,41.1,1.02h0A9.292,9.292,0,0,0,36.745,0a11.3,11.3,0,0,0-4.667,1.02L5.333,14.431A9.424,9.424,0,0,0,1.412,18,9.67,9.67,0,0,0,0,23.137V54.9a10.35,10.35,0,0,0,1.451,5.255,9.06,9.06,0,0,0,4.2,3.765L32.471,77.334a9.6,9.6,0,0,0,2.118.745,9.7,9.7,0,0,0,2.2.275,9.205,9.205,0,0,0,2.314-.275,10.158,10.158,0,0,0,2-.745L67.922,63.922A10.331,10.331,0,0,0,72,60.275,9.583,9.583,0,0,0,73.569,54.9V23.137a9.315,9.315,0,0,0-5.647-8.706ZM35.451,6.667a1.042,1.042,0,0,1,.667-.275q.431-.039.667-.039a6.5,6.5,0,0,1,.784.039.921.921,0,0,1,.549.275L62.9,19.059l-9.412,4.706L27.451,10.745Zm1.333,25.49-26.118-13.1,9.412-4.627,26.039,13.02ZM8.314,58.275a4.47,4.47,0,0,1-1.176-1.412,3.447,3.447,0,0,1-.471-1.647V24.471L33.412,37.8V70.589Zm56.549,0L40.157,70.589V37.8L66.9,24.471V55.216a3.048,3.048,0,0,1-.51,1.765A4.232,4.232,0,0,1,64.863,58.275Z'
    />
  </svg>
)

export default Package
